import React, { lazy } from 'react';
import { CheckCircleIcon, ClockIcon, StarIcon } from 'lucide-react';
export function RecipesSample() {
  return <section id="recipes-sample" className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-white to-orange-50" data-id="element-455">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-456">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-3 sm:mb-4" data-id="element-457">
          Descubre Nuestras Recetas
        </h2>
        <p className="text-center text-sm sm:text-base md:text-lg text-gray-600 mb-8 sm:mb-12 max-w-2xl mx-auto" data-id="element-458">
          Recetas probadas y aprobadas por familias reales. Diseñadas para tu
          vida ocupada.
        </p>
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-16 items-center" data-id="element-459">
          {/* Image Side */}
          <div className="order-2 lg:order-1" data-id="element-460">
            <div className="relative" data-id="element-461">
              <div className="absolute -inset-3 bg-gradient-to-r from-orange-200 to-orange-100 rounded-2xl blur-2xl opacity-30" data-id="element-462"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-463">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1hC6RZ4TF9KwJY5Wvngh7G/mujer_profesional_leyendo_50_recetas.png" alt="Profesional leyendo 50 Recetas de 15 Minutos" loading="lazy" className="w-full h-auto object-cover" data-id="element-464" />
              </div>
            </div>
          </div>
          {/* Content Side */}
          <div className="order-1 lg:order-2 space-y-5 sm:space-y-6" data-id="element-465">
            <div className="bg-white p-5 sm:p-6 md:p-8 rounded-2xl shadow-xl border-2 border-orange-100" data-id="element-466">
              <h3 className="font-bold text-xl sm:text-2xl md:text-3xl mb-4 sm:mb-6 text-orange-600" data-id="element-467">
                ¿Qué Hace Estas Recetas Especiales?
              </h3>
              <div className="space-y-4 sm:space-y-5" data-id="element-468">
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-469">
                  <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-470">
                    <ClockIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" data-id="element-471" />
                  </div>
                  <div data-id="element-472">
                    <div className="font-semibold text-base sm:text-lg text-gray-900 mb-1" data-id="element-473">
                      Cronometradas con Precisión
                    </div>
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed" data-id="element-474">
                      Cada receta fue probada con reloj en mano. 15 minutos
                      significa 15 minutos reales.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-475">
                  <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-476">
                    <CheckCircleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" data-id="element-477" />
                  </div>
                  <div data-id="element-478">
                    <div className="font-semibold text-base sm:text-lg text-gray-900 mb-1" data-id="element-479">
                      Ingredientes Accesibles
                    </div>
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed" data-id="element-480">
                      Sin ingredientes raros. Todo lo que necesitas está en tu
                      supermercado local.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-481">
                  <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-482">
                    <StarIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600 fill-orange-600" data-id="element-483" />
                  </div>
                  <div data-id="element-484">
                    <div className="font-semibold text-base sm:text-lg text-gray-900 mb-1" data-id="element-485">
                      Aprobadas por Familias
                    </div>
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed" data-id="element-486">
                      Más de 1,200 familias ya están cocinando con estas recetas
                      cada semana.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-white p-5 sm:p-6 md:p-8 rounded-2xl border-2 border-orange-200 shadow-lg" data-id="element-487">
              <div className="text-center" data-id="element-488">
                <div className="text-4xl sm:text-5xl md:text-6xl font-bold text-orange-600 mb-2" data-id="element-489">
                  50
                </div>
                <div className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-2" data-id="element-490">
                  Recetas Completas
                </div>
                <div className="text-sm sm:text-base text-gray-600" data-id="element-491">
                  Desde pastas express hasta ensaladas completas y one-pot meals
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Bottom Stats Bar */}
        <div className="mt-12 sm:mt-16 grid grid-cols-3 gap-4 sm:gap-6 max-w-3xl mx-auto" data-id="element-492">
          <div className="bg-white p-4 sm:p-6 rounded-xl shadow-lg text-center" data-id="element-493">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-orange-600 mb-2" data-id="element-494">
              15min
            </div>
            <div className="text-xs sm:text-sm md:text-base text-gray-600 font-medium" data-id="element-495">
              Por receta
            </div>
          </div>
          <div className="bg-white p-4 sm:p-6 rounded-xl shadow-lg text-center" data-id="element-496">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-orange-600 mb-2" data-id="element-497">
              100%
            </div>
            <div className="text-xs sm:text-sm md:text-base text-gray-600 font-medium" data-id="element-498">
              Probadas
            </div>
          </div>
          <div className="bg-white p-4 sm:p-6 rounded-xl shadow-lg text-center" data-id="element-499">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-orange-600 mb-2" data-id="element-500">
              1,200+
            </div>
            <div className="text-xs sm:text-sm md:text-base text-gray-600 font-medium" data-id="element-501">
              Familias
            </div>
          </div>
        </div>
      </div>
    </section>;
}